function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m285.78 175.179c-1.023-29.388-5.033-56.684-11.564-78.058-7.943-25.994-16.519-32.669-18.239-32.942-.007 0-.013 0-.02 0-1.657.275-10.231 6.952-18.173 32.942-6.531 21.374-10.541 48.67-11.564 78.058z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256.023 316.179h.02c1.657-.275 10.231-6.952 18.173-32.941 6.531-21.374 10.541-48.67 11.564-78.058h-59.56c1.023 29.388 5.033 56.684 11.564 78.058 7.943 25.994 16.519 32.668 18.239 32.941z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.498 70.856c11.748 27.032 18.016 65.676 19.3 104.323h65.306c-5.805-48.703-39.493-88.97-84.606-104.323z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m215.502 309.502c-11.748-27.032-18.016-65.676-19.3-104.323h-65.306c5.805 48.704 39.493 88.971 84.606 104.323z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m196.202 175.179c1.284-38.647 7.551-77.291 19.3-104.323-45.113 15.353-78.801 55.62-84.605 104.323z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m315.798 205.179c-1.284 38.647-7.551 77.291-19.3 104.323 45.113-15.353 78.801-55.62 84.605-104.323z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m412 190.179c0 52.316-25.888 98.697-65.524 127.013h165.524v-237.025c0-24.853-20.147-45-45-45h-193.5c77.811 8.726 138.5 74.91 138.5 155.012z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 347.192v14.308c0 24.853 20.147 45 45 45h110.667v40.333h-32.577c-8.077 0-15.027 6.207-15.407 14.275-.406 8.614 6.458 15.725 14.983 15.725h266.244c8.077 0 15.027-6.207 15.407-14.275.406-8.614-6.458-15.725-14.983-15.725h-33v-40.333h110.666c24.853 0 45-20.147 45-45v-14.308z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m165.524 317.192c-39.636-28.315-65.524-74.697-65.524-127.013 0-80.102 60.689-146.286 138.5-155.013h-193.5c-24.853 0-45 20.147-45 45v237.026z"
}));

var SvgWeb = function SvgWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/web.06bdc7ef.svg";
export { ForwardRef as ReactComponent };